import React, { useEffect, useState } from 'react'

import { navigationProgress } from './navigation-progress'

/**
 * A thin fixed top progress bar shown while a route transition is blocked on the
 * RBAC ability check (adminShellOnEnter / abilityOnEnter await /me/ability inside
 * react-router-3's onEnter). Without it a menu click feels dead — the transition
 * silently waits on the network. Subscribes to the framework-agnostic
 * `navigationProgress` store the (non-React) route gates signal.
 */
export function NavigationProgressBar(): React.ReactElement | null {
  const [active, setActive] = useState<boolean>(navigationProgress.isActive())
  useEffect(() => navigationProgress.subscribe(setActive), [])
  if (!active) {
    return null
  }
  return (
    <div
      role="progressbar"
      aria-label="Loading"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        zIndex: 2000,
        overflow: 'hidden',
        background: 'transparent',
      }}
    >
      <div
        style={{
          height: '100%',
          width: '40%',
          background: '#0f4c81',
          borderRadius: 3,
          animation: 'rbac-nav-progress 1s ease-in-out infinite',
        }}
      />
      <style>{`
        @keyframes rbac-nav-progress {
          0%   { margin-left: -40%; }
          100% { margin-left: 100%; }
        }
      `}</style>
    </div>
  )
}
